<script>
import Sidebar from '@/layout/Sidebar';

export default {
  components: {
    Sidebar,
  },
};
</script>

<template>
  <Sidebar />
</template>

<style lang="scss">
  .help {
    &__title {
      color: #FFF;
      font-size: 20px;
      margin-bottom: 16px;
    }

    &__content {
      line-height: 1.5;
      color: #b2b8c5;
      margin-bottom: 48px;
      letter-spacing: .32px;
    }
  }
</style>
